import { useTranslation } from "react-i18next";
import React, { useState } from "react";
const ConfirmModal = (props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const confirmAction = async () => {
    setLoading(true);
    await props.handleChange(props.params);
    setLoading(false);
  };
  return (
    <div className="p-2">
      <h6 className="p-2">{props.messageConfirm}</h6>
      <div className="d-flex gap-2 justify-content-center mt-3">
        <button className="p-2" onClick={props.closeModal}>
          {t("cancel")}
        </button>
        <button className={`p-2 text-white bg-blue`} onClick={confirmAction}>
          {loading ? (
            <span className="spinner-border spinner-border-sm m-1 "></span>
          ) : (
            t("confirm")
          )}
        </button>
      </div>
    </div>
  );
};

export default ConfirmModal;
